import { render } from "./Agreements.vue?vue&type=template&id=588e16d4&scoped=true"
import script from "./Agreements.vue?vue&type=script&lang=js"
export * from "./Agreements.vue?vue&type=script&lang=js"

import "./custom-agreements.scss?vue&type=style&index=0&id=588e16d4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588e16d4"]])

export default __exports__